






import SplashScreen from '@/types/components/SplashScreen.interface'
import Vue from 'vue'
import { mapGetters } from 'vuex'
export default Vue.extend({
    props: {
        //  The name of the app location that is hosting the button
        sender: {
            type: String,
            default: ''
        },
        //  The width of the button
        width: {
            type: [Number, String],
            default: 200
        }
    },
    methods: {
        qboConnect(): void {
            //  Fetch the tenant's data provider
            const provider = this.$store.getters.tenant.data_provider

            //  We allow a connection if the data provider is NULL or already set to QBO
            if (!provider || provider === 'QBO') {
                this.qboConnectExecute()
            }
        },
        qboConnectExecute(): void {
            //  Assemble a splash screen
            const splash: SplashScreen = { message: 'Connecting to QuickBooks Online...' }

            //  Show the splash screen loader
            this.$store.commit('splashSet', splash)

            //  Assemble grant url with tenant api endpoint
            const url = `${this.$store.getters.api}/qbo/oauth/connect/redirect?sender=${this.sender}`

            //  Intuit Anywhere setup
            window.intuit.ipp.anywhere.setup({
                menuProxy: '',
                grantUrl: url,
                datasources: {
                    quickbooks: true
                }
            })

            //  Pop connect to intuit window
            window.intuit.ipp.anywhere.controller.onConnectToIntuitClicked()
        }
    }
})
